/**
 * Keep this sync'd with SublocationWorkPerformedType enum in BE.
 */
export const SUBLOCATION_WORKPERFORMED_TYPE = {
  NONE: 0,
  NESTEDLOCATION: 1,
  ALIGNMENT: 2,
  COORDINATES: 3,
};

/**
 * Group of all special SUBLOCATION_WORKPERFORMED_TYPE's.
 * @example <caption>Example usage of SPECIAL_SUBLOCATIONS</caption>
 * // Determines whether a subLocWp is 'special':
 * SPECIAL_SUBLOCATIONS.includes(locWp.sublocationWorkPerformedType) === true;
 */
export const SPECIAL_SUBLOCATIONS = [
  SUBLOCATION_WORKPERFORMED_TYPE.ALIGNMENT,
  SUBLOCATION_WORKPERFORMED_TYPE.COORDINATES,
];
